import SearchLectureSelect from "@/pcomponents/common/content/basic/student/search/search_lecture_select";
import SearchBtn from "@/pcomponents/common/crud/list/search/btn/search_btn";

function SearchArea(props: any) {
  let myProps = {
    xColumnArr: {},
    listOpt: {},
    setListOpt: (inOptObj: any) => { },
    list: (inOptObj: any) => { },
    is_show_search_area: true,
    show_search_key_arr: [],
    search_bottom_area: "",
    ...props
  };
  let xColumnArr = myProps.xColumnArr;
  let listOpt = myProps.listOpt;

  const handleInputChange = (event: any) => {
    const target = event.target;
    let value = target.value;
    const name = target.name;
    if (target.type === 'checkbox' || target.type === 'radio') {
      value = "";
      if (target.checked) {
        value = target.value;
      }
    }
    let tmp_listOpt = { ...listOpt };
    tmp_listOpt.now_page = "1";
    tmp_listOpt[name] = value;
    if (target.tagName.toLowerCase() === "select"
      || target.type === "checkbox" || target.type === "radio") {
      myProps.list(tmp_listOpt);
    } else {
      myProps.setListOpt(tmp_listOpt);
    }
  };

  let show_search_key_arr = [
    "s_search_text",
    "s_stu_lecture_seq",
    "s_stu_grade",
    "s_stu_state",
  ];
  if (myProps.show_search_key_arr && myProps.show_search_key_arr.length > 0) {
    show_search_key_arr = myProps.show_search_key_arr;
  }
  const get_search_input_tags = () => {
    let search_input_tags: any = show_search_key_arr.map((key: string, idx: number) => {
      return (
        <span key={idx}>
          {key == "s_search_text" &&
            <input type="text" className="search-input" name="s_search_text"
              style={{ width: 80 }} placeholder="이름" value={listOpt.s_search_text}
              onChange={handleInputChange}
              autoComplete="off"
              onKeyUp={(e: any) => { if (e.key === 'Enter') { myProps.list({ "now_page": 1 }); } }} />
          }
          {key == "s_stu_lecture_seq" &&
            <SearchLectureSelect
              name="s_stu_lecture_seq"
              value={listOpt.s_stu_lecture_seq}
              on_change_input={(inData: any) => {
                let name = inData.name;
                let value = inData.value;
                myProps.list({ now_page: 1, [name]: value });
              }}
              wrap_style={{ width: 90, display: "inline-block" }}
              select_title_style={{ lineHeight: "28px", height: 28, overflow: "hidden" }}
            ></SearchLectureSelect>
          }
          {key == "s_stu_grade" &&
            <select className="search-input_select" name="s_stu_grade" value={listOpt.s_stu_grade}
              onChange={handleInputChange}>
              <option value="">학년</option>
              <option value="baby">미취학</option>
              <option value="elementary">초</option>
              <option value="middle">중</option>
              <option value="high">고</option>
              {
                xColumnArr.select_arr.a_stu_grade.map((item: any, idx: number) => {
                  if (item.value < 8) {
                    return "";
                  }
                  return (
                    <option value={item.value} key={idx}>{item.text}</option>
                  );
                })
              }
            </select>
          }
          {key == "s_stu_state" &&
            <select className="search-input_select" name="s_stu_state" value={listOpt.s_stu_state}
              onChange={handleInputChange} style={{ width: 60 }} >
              <option value="">현황</option>
              <option value="now,ready">대기,재원</option>
              {
                xColumnArr.select_arr.a_stu_state.map((item: any, idx: number) => {
                  return (
                    <option value={item.value} key={idx}>{item.text}</option>
                  );
                })
              }
            </select>
          }
        </span>
      );
    });

    return search_input_tags;
  };

  return (
    <div className="relative">
      {myProps.is_show_search_area &&
        <div className="search-box-between">
          {get_search_input_tags()}
          <SearchBtn
            on_click={() => { myProps.list({ "now_page": 1 }); }}
          ></SearchBtn>
        </div>
      }
      {myProps.search_bottom_area}
    </div>
  );
};
export default SearchArea;